export enum MapPoints {
  ADMINISTRATIVE = 'administrative',
  ADMINISTRATIVE_LANDPARCEL = 'administrative.land_parcel',
  ADMINISTRATIVE_NEIGHBORHOOD = 'administrative.neighborhood',
  POI_ATTRACTION = 'poi.attraction',
  POI_BUSINESS = 'poi.business',
  POI_GOVERNMENT = 'poi.government',
  POI_MEDICAL = 'poi.medical',
  POI_PARK = 'poi.park',
  POI_PLACE_OF_WORSHIP = 'poi.place_of_worship',
  POI_SCHOOL = 'poi.school',
  POI_SPORTS_COMPLEX = 'poi.sports_complex',
  ROAD = 'road',
  ROAD_ARTERIAL = 'road.arterial',
  ROAD_HIGHWAY = 'road.highway',
  ROAD_HIGHWAY_CONTROLLED = 'road.highway.controlled_access',
  ROAD_LOCAL = 'road.local',
  LABELS_ICON = 'labels.icon',
  LABELS_TEXT = 'labels.text',
  LABELS_TEXTFILL = 'labels.text.fill',
  LABELS_TEXTSTROKE = 'labels.text.stroke',
  TRANSIT = 'transit',
  TRANSIT_LINE = 'transit.line',
  TRANSIT_STATION = 'transit.station',
  WATER = 'water',
}
